<template>
    <div class="screenStyle">
      <el-form ref="ruleForm" label-width="80px" style="padding-top: 30px;">
        <el-form-item label="itemid:">
          <el-input v-model="uploadType.itemid" placeholder="请输入" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" clearable style="width: 70%;" size="small"></el-input>
        </el-form-item>
        <el-form-item label="skuid:">
          <el-input v-model="uploadType.skuid" placeholder="请输入" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" clearable style="width: 70%;" size="small"></el-input>
        </el-form-item>
        <el-form-item label="低价截图:" v-if="uploadType.itemid && uploadType.skuid">
          <el-upload
            class="avatar-uploader"
            action="/hcm/iprScreenshot/headUpload"
            :show-file-list="false"
            :before-upload="handleBeforeUpload"
            :on-success="handleUploadSuccess"
            accept="image/png, image/jpg"
            ref="elUpload"
            :data="uploadType">
            <img v-if="imageUrl" :src="imageUrl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="低价截图:" v-else>
          请先填写itemid和skuid
        </el-form-item>
      </el-form>
      <el-button type="TheCustom" style="margin-left: 100px;" size="small" @click="clearCli">清 空</el-button>
  </div>
</template>
<script>
    export default {
        data() {
            return {
              uploadType: {
        				itemid: '',
                skuid: '',
        			},
              imageUrl: '',
            };
        },
        mounted() {

        },
        methods: {
          handleBeforeUpload(file) {
            const isLt20M = file.size / 1024 / 1024 < 20;
            if (!isLt20M) {
              this.$message.error('上传文件大小不能超过 20MB!');
            }
            return isLt20M;
          },
          handleUploadSuccess(res) {
            this.imageUrl = res.data.data
            if (this.imageUrl) {
              this.$notify({
                title: '成功',
                message: '上传成功',
                type: 'success'
              });
            }
          },
          clearCli() {
            this.imageUr = ''
            this.uploadType.itemid = ''
            this.uploadType.skuid = ''
          },
        },
    };
</script>

<style lang="scss">
  .screenStyle {
    background: white;
    width: 100%;
    height: 100vh;
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>
